import { CheckOutlined, LoadingOutlined } from "@ant-design/icons";
import {
  Button,
  Checkbox,
  Col,
  Form,
  Input,
  Modal,
  Row,
  Select,
  Spin,
} from "antd";
import React, { useEffect, useState } from "react";
import { GetActiveAttributesApi } from "../../../api/attributes/GetActiveAttributesApi";
import EditPlanLevelsApi from "../../../api/EditPLanLevelsApi";
import {
  openNotificationError,
  openNotificationSuccess,
} from "../../../helpers/NotificationHelpers";
import Theme from "../../../theme/Theme";
import ColorPicker from "../../sub/ColorPicker";

function EditPlanLevelModal(props) {
  const [submit, setSubmit] = useState(false);
  const [attributes, setAttributes] = useState([]);
  const [color, setColor] = useState("");
  const [valuesChanged, setValuesChanged] = useState(false);

  useEffect(() => {
    setColor(props.planLevel?.color);
  }, [props.planLevel, props.visible]);

  function handleCancel() {
    props.handleCancel();
    setAttributes([]);
    setSubmit(false);
    setValuesChanged(false);
  }

  useEffect(() => {
    if (props.visible) {
      getAttributes();
    }
  }, [props.visible]);

  async function getAttributes() {
    const apiResponse = await GetActiveAttributesApi();
    if (apiResponse.success) {
      setAttributes(apiResponse.data);
    }
  }

  function attributeInitialValue() {
    let output = [];

    props.planLevel?.targetDate && output.push("targetDate");
    props.planLevel?.target && output.push("target");
    props.planLevel?.description && output.push("description");
    props.planLevel?.kpi && output.push("kpi");
    props.planLevel?.tasks && output.push("tasks");

    return output;
  }

  function customAttributeInitialValue() {
    let output = [];

    props.planLevel?.planLevelAttributes?.forEach((attribute) => {
      output.push(attribute.id);
    });

    return output;
  }

  async function onFinish(value) {
    setSubmit(true);
    const apiResponse = await EditPlanLevelsApi(
      props.planLevel?.id,
      value.name,
      color,
      value.attributes?.includes("targetDate"),
      value.attributes?.includes("kpi"),
      value.attributes?.includes("target"),
      value.attributes?.includes("description"),
      value.attributes?.includes("tasks"),
      value.customAttributes
    );

    if (apiResponse.statusCode) {
      openNotificationError("bottomRight", apiResponse.message);
    } else if (apiResponse.success) {
      openNotificationSuccess("bottomRight", "Level edited successfully");
      props.handleOk();
    } else {
      openNotificationError(
        "bottomRight",
        "Couldn't edit level. Try again later."
      );
    }
    handleCancel();
  }

  function renderAttributes() {
    let output = [];
    attributes?.forEach((attribute) => {
      output.push(
        <Col span={8}>
          <Checkbox value={attribute.id}>{attribute.name}</Checkbox>
        </Col>
      );
    });
    return output;
  }

  return (
    <Modal
      title="Edit plan level"
      visible={props.visible}
      onCancel={() => handleCancel()}
      footer={null}
      destroyOnClose={true}
    >
      <Form
        name="addOrgLevel"
        onFinish={onFinish}
        layout="vertical"
        requiredMark={false}
        autoComplete="off"
        initialValues={{
          name: props.planLevel?.name,
          order: props.planLevel?.order,
          attributes: attributeInitialValue(),
          customAttributes: customAttributeInitialValue(),
        }}
        onValuesChange={() => {
          setValuesChanged(true);
        }}
      >
        <Form.Item label="Order*" name="order">
          <Select disabled placeholder="Select order"></Select>
        </Form.Item>

        <Form.Item
          label="Level name*"
          name="name"
          rules={[
            {
              required: true,
              message: "Please enter level name!",
            },
          ]}
        >
          <Input placeholder="Level name" />
        </Form.Item>

        <Form.Item label="Color*" name="color">
          <div className="w-20 h-8">
            <ColorPicker color={color} onChange={(value) => setColor(value)} />
          </div>
        </Form.Item>

        <Form.Item label="Attributes*" name="attributes">
          <Checkbox.Group style={{ width: "100%" }}>
            <Row>
              <Col span={8}>
                {props.planLevel?.order === 1 ? (
                  <div className="flex items-center">
                    <div
                      className="mr-2 w-4 h-4 rounded flex justify-center items-center"
                      style={{
                        backgroundColor: Theme().primary,
                      }}
                    >
                      <CheckOutlined
                        style={{ fontSize: "10px", color: "#fff" }}
                      />
                    </div>
                    Target
                  </div>
                ) : (
                  <Checkbox value="target">Target</Checkbox>
                )}
              </Col>
              <Col span={8}>
                <Checkbox value="targetDate">Target date</Checkbox>
              </Col>
              <Col span={8}>
                <Checkbox value="description">Description</Checkbox>
              </Col>
              <Col span={8}>
                <Checkbox value="kpi">KPI</Checkbox>
              </Col>
              <Col span={8}>
                <Checkbox value="tasks">Tasks</Checkbox>
              </Col>
            </Row>
          </Checkbox.Group>
        </Form.Item>

        {!!attributes?.length && (
          <Form.Item name="customAttributes">
            <Checkbox.Group style={{ width: "100%" }}>
              <Row>{renderAttributes()}</Row>
            </Checkbox.Group>
          </Form.Item>
        )}

        <Form.Item style={{ marginBottom: 0 }}>
          <div className=" flex justify-end">
            <Button className="mr-3 w-28" onClick={() => handleCancel()}>
              Cancel
            </Button>
            <Button
              className="btn w-28"
              type="primary"
              htmlType={submit && "submit"}
              disabled={submit || !valuesChanged}
            >
              {submit ? (
                <Spin
                  size="small"
                  indicator={<LoadingOutlined style={{ color: "#fff" }} spin />}
                />
              ) : (
                "Save"
              )}
            </Button>
          </div>
        </Form.Item>
      </Form>
    </Modal>
  );
}

export default EditPlanLevelModal;
